import { Badge } from '@round/whitelabel-ui';
import cn from 'classnames';
import styles from './AllocationBadge.module.css';
import capitalize from 'lodash/capitalize';
import { Currency } from '@round/api';
import { asMoneyInKNotation, asMoneyWithoutZeros, getExponent } from 'helpers';
import { Tooltip } from '@round/whitelabel-ui';

type AllocationState = 'unallocated' | 'partially-allocated' | 'fully-allocated' | string;

type Props = {
    originalAmount: number;
    allocatedAmount: number;
    currency: Currency | null;
};

const AllocationBadge = ({ originalAmount, allocatedAmount, currency }: Props) => {
    const remainingAmount = originalAmount - allocatedAmount;

    const allocationStatus: AllocationState =
        allocatedAmount === 0 ? 'unallocated' : remainingAmount === 0 ? 'fully-allocated' : 'partially-allocated';

    const allocationLabel: AllocationState = (() => {
        if (allocationStatus !== 'partially-allocated') {
            return allocationStatus.split('-').map(capitalize).join(' ');
        }

        return `${asMoneyInKNotation({
            amount: remainingAmount,
            currency: currency ?? undefined,
            threshold: 5,
        })} unallocated`;
    })();

    return (
        <Tooltip.Root>
            {(anchor, setAnchor) => (
                <>
                    <Badge ref={setAnchor} className={cn(styles.allocationBadge, styles[allocationStatus])}>
                        {allocationLabel}
                    </Badge>
                    <Tooltip anchorElement={anchor} disabled={getExponent(remainingAmount) <= 5}>
                        <Tooltip.Body>
                            <span>{asMoneyWithoutZeros(remainingAmount, currency ?? undefined)}</span>
                        </Tooltip.Body>
                    </Tooltip>
                </>
            )}
        </Tooltip.Root>
    );
};

export default AllocationBadge;
